import { useLocation, Outlet } from 'react-router-dom';
import Dashboard from "../Pages/dashboard/Dashboard";

const DashboardLayout = () => {
    const location = useLocation();

    return (
        <div className="main-layout">
            <div style={{
                display: location.pathname === '/' ? 'block' : 'none',
            }}>
                <Dashboard />
            </div>

            <Outlet />
        </div>
    );
};

export default DashboardLayout